import {Link} from "react-router-dom";
import React from "react";

export const NavBarNoAuth = function(props) {
    return (
        <nav>
            <ul>
                <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/devices">My Sim GPS</Link>
                </li>
            </ul>
        </nav>

    );
};

export const NavBarWithAuth = function(props) {
    return (
        <nav>
            <ul>
                <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/devices">My Devices</Link>
                </li>
                <li>
                    <Link to="/orders">My Orders</Link>
                </li>
            </ul>
        </nav>
    );
};

